module.exports = __webpack_public_path__ + "static/img/pic_2_1@2x.9109d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/shortVideo/pic_2_1@2x.png
// module id = erUA
// module chunks = 0